module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("a5caE"))).then(() => parcelRequire('hEqeo'));